<template>
  <div>
    <v-dialog v-model="dialog">
      <v-row justify="center">
        <v-card>
          <v-card-title>
            <span class="text-h5">Pravna osoba</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="UID/OIB*"
                    v-model="pravna_osoba.oib"
                    hint="Ukoliko osobi ne znate oib automatski će se zapisati jedinstveni identifikator"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Naziv firme*"
                    required
                    v-model="pravna_osoba.ime"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Prezime*"
                    required
                    v-model="pravna_osoba.prezime"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Email*"
                    v-model="pravna_osoba.email"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Broj telefona*"
                    v-model="pravna_osoba.broj_telefona"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    name="opis"
                    label="Opis"
                    v-model="pravna_osoba.opis"
                    hint="Unesite opis osobe"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Adresa*"
                    v-model="pravna_osoba.adresa.adresa"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Poštanski broj*"
                    required
                    v-model="pravna_osoba.adresa.post_br"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Grad*"
                    v-model="pravna_osoba.adresa.grad"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <small>*obavezna polja</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text> Odustani </v-btn>
            <v-btn color="blue darken-1" text @click="obradiPromjene()">
              Pohrani
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-dialog>
  </div>
</template>

<script>
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
export default {
  name: "pers_data",
  props: {
    pravna_osoba: {
        type: Object,
        required: false,
        default: {
          ime: "",
          broj_telefona:"",
          oib: Date.now(),
          email: "",
          opis: "",
          adresa: {
            adresa: "",
            post_br: "",
            grad: "",
          },
        },
    },
    isNew: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      dialog: true,
    };
  },

  methods: {
    obradiPromjene() {
      console.log("Tu je ");
      console.log(this.isNew);
      if (this.isNew) {
        this.createOsoba();
      } else {
        this.updateOsoba();
      }
    },
    createOsoba() {
      //if prolazi provjeru
      //Poziv na api koji kreira osobu
      osobe.insertPravna(this.pravna_osoba);
    },

    updateOsoba() {
      osobe.updatePravna(this.pravna_osoba, this.pravna_osoba.oib);
      //if prolazi provjeru
      //Poziv na api koji ažurira osobu
    },
  },
};
</script>

<style>
</style>